module.exports = __webpack_public_path__ + "assets/img/hdlc.1b3f0ccd.png";